export interface AdVideo {
  id: string;
  title: string;
  videoUrl: string;
  hour: number;
  type: "video" | "image";
  startTime?: string;
  endTime?: string;
}

export const fetchAds = async ({
  API_URL,
  formattedDate,
}: {
  API_URL: string;
  formattedDate: string;
}): Promise<AdVideo[]> => {
  try {
    const response = await fetch(
      `${API_URL}videos/metadata?date=${formattedDate}`
    );
    const data = await response.json();

    return data.videos.map((item: any, index: number) => ({
      id: item.video_id,
      title: item.filename,
      videoUrl: `${API_URL}videos/${item.video_id}/download`,
      hour: index,
      type:
        item.media_type === "image"
          ? "image"
          : "video",
      startTime: item.start_time,
      endTime: item.end_time,
    }));
  } catch (error) {
    console.log(error);
    return [];
  }
};